import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

interface FormFieldError {
  key: string;
  value:
    | string
    | boolean
    | { requiredLength?: number; min?: number; max?: number };
}

const ERRORS: Record<string, string> = {
  required: "libs.validation.required",
  minlength: "libs.validation.minlength",
  maxlength: "libs.validation.maxlength",
  email: "libs.validation.email",
  pattern: "libs.validation.pattern",
  min: "libs.validation.min",
  max: "libs.validation.max",
  requiredTrue: "libs.validation.requiredTrue",
  whitespace: "libs.validation.whitespace",
};

@Pipe({
  name: "parseError",
})
export class ParseErrorPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  public transform(error: FormFieldError, label: string): string {
    if (typeof error.value === "string") {
      return this.translate.instant(error.value, { label });
    }
    const errorKey = ERRORS[error.key] ?? "libs.validation.unknown";

    if (typeof error.value === "object") {
      return this.translate.instant(errorKey, {
        label,
        requiredLength: error.value.requiredLength,
        min: error.value.min,
        max: error.value.max,
      });
    }

    return this.translate.instant(errorKey, { label });
  }
}
